import { useIntl } from "react-intl"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import FourOFour from "../../assets/illustration_404.webp"
import * as Ct from "ldlj"
import { setCompanyStatusForUser } from "../../store/ducks/companies.ducks"
import { useDispatch } from "react-redux"
import { Background } from "../../components/Background"

const NotFound404 = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const redirectHome = () => {
    // We need to decide where this should really redirect to since there is no actual home page
    dispatch(setCompanyStatusForUser())
    navigate("/")
  }

  return (
    <Background centeredTop={true}>
      <Ct.Card radius={1.5}>
        <ImageContainer>
          <img src={FourOFour} alt="404 Not Found" width="100%" height="100%" />
        </ImageContainer>
        <Ct.Spacer height={5} />
        <Ct.Text
          text={intl.formatMessage({ id: "404.text" })}
          textStyle={{
            textTransform: "initial",
            fontSize: 2.25,
            fontWeight: 700,
          }}
        />
        <Ct.Spacer height={5} />
        <Ct.Button
          width={31}
          height={7}
          label={intl.formatMessage({ id: "404.link" })}
          onClick={redirectHome}
        />
      </Ct.Card>
    </Background>
  )
}

export default NotFound404

const ImageContainer = styled.div`
  margin-top: 2rem;
  width: 100%;
  height: 100%;
`
